<template>
  <div id="skyView">
    <div id="textBox" v-if="this.currentWishes[this.personIndex] != undefined">
      <h4 class="text-center">{{ this.currentWishes[this.personIndex].name }}</h4>
      <div v-if="this.currentWishes[this.personIndex].picture != null">
        <img id="pictureBox" :src="currentWishes[personIndex].picture" />
      </div>
      <div>
        <p v-for="(item,i) in this.currentWishes[this.personIndex].paragraphs" :key="i"> {{ item }}</p>
      </div>
    </div>
    <div id="skyUI">
      <b-row>
        <b-col cols="5">
          <h6 class="mt-2">Select Name</h6>
          <b-form-select v-model="personIndex" :options="nameUI" size="sm" @change="selectPersonUI"></b-form-select>
        </b-col>
        <b-col cols="7">
          <div class="float-right mt-3 mr-3">
            <b-button variant="dark" @click="decreaseIndex" class="mr-2">
              <img class="icon" src="@/assets/img/UI_Previous.png">
            </b-button>
            <b-button variant="dark" @click="increaseIndex" class="mr-2">
              <img class="icon" src="@/assets/img/UI_Next.png">
            </b-button>
            <b-button variant="dark" @click="skyToTree">
              <img class="icon" src="@/assets/img/UI_Tree.png">
            </b-button>
          </div>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import * as d3 from "d3"
import { mapState } from 'vuex'

export default {
    name: "SkyView",
    data: () => ({
      personIndex: 0,
    }),
    computed: {
      ...mapState([
        "currentGroup",
        "currentWishes",
      ]),
      nameUI: function() {
        return this.currentWishes.map((d,i) => {
            return {value: i, text: d.name}
          })
      },
    },
    methods: {
      selectPersonUI: function() {
        d3.select("#textBox").property('scrollTop', 0)
      },
      increaseIndex: function() {
        this.personIndex += 1;
        if (this.personIndex >= this.currentWishes.length) {
          this.personIndex = 0;
        }
        d3.select("#textBox").property('scrollTop', 0)
      },
      decreaseIndex: function() {
        this.personIndex -= 1;
        if (this.personIndex < 0) {
          this.personIndex = this.currentWishes.length - 1;
        }
        d3.select("#textBox").property('scrollTop', 0)
      },
      skyToTree: function() {
        this.$emit("skyToTree");        
      }
    },
    mounted: function () {
    },  
}
</script>

<style scoped>
#skyView {
  position: absolute;
  width: 800px;
  height: 600px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;  
}

#textBox {
  background: black;
  border-radius: 15px;
  opacity: 09;
  width: 800px;
  height: 480px;
  overflow-x: hidden;
  overflow-y: auto;
  color: white;
  padding: 20px;
}

#textBox p, #textBox h4 {
  color: white;
}

#pictureBox {
  width: 720px;
  margin: 20px;
}

.icon {
  height: 40px;
}

@media only screen and (max-width: 800px) {
  #skyView {
    width: 360px;
    height: 600px;
  }

  #pictureBox {
    width: 320px;
    margin: 0px;
  }

  #textBox {
    width: 360px;
    height: 500px;
  }

  .icon {
    height: 20px;
  }

}

</style>
